

// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { jwtDecode } from "jwt-decode";
// import {
//   FolderOpen,
//   Users,
//   Calendar,
//   CheckCircle,
//   Clock,
//   AlertTriangle,
//   TrendingUp,
//   Sparkles,
//   Zap,
//   Star,
//   Activity,
//   Plus,
//   ArrowRight,
//   Target,
//   BarChart3,
//   ChevronRight
// } from 'lucide-react';

// const Dashboard = ({ projects = [], employees = [], milestones = [], onNavigate }) => {
//   const navigate = useNavigate();

//   // ---------- State for company employees ----------
//   const [companyEmployees, setCompanyEmployees] = useState([]);
//   const [employeeLoading, setEmployeeLoading] = useState(true);

//   // ---------- State for company projects ----------
//   const [companyProjects, setCompanyProjects] = useState([]);
//   const [projectsLoading, setProjectsLoading] = useState(true);

//   // ---------- State for custom statuses ----------
//   const [statusOptions, setStatusOptions] = useState([]);
//   const [statusLoading, setStatusLoading] = useState(true);

//   // ---------- Fetch company employees ----------
//   useEffect(() => {
//     const fetchCompanyEmployees = async () => {
//       try {
//         const token = localStorage.getItem('authToken');
//         if (!token) {
//           setEmployeeLoading(false);
//           return;
//         }

//         const decodedToken = jwtDecode(token);
//         const COMPANY_ID = decodedToken.role === 'company' 
//           ? (decodedToken.companyId || decodedToken.id) 
//           : decodedToken.companyId;

//         const response = await fetch(`https://slateblue-mallard-430836.hostingersite.com/api/employees/company/${COMPANY_ID}`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json',
//           },
//         });

//         if (response.ok) {
//           const employeesData = await response.json();
//           setCompanyEmployees(Array.isArray(employeesData) ? employeesData.filter(emp => emp.isActive !== false) : (employeesData.data || []).filter(emp => emp.isActive !== false));
//         } else {
//           console.error('Failed to fetch company employees:', response.status, response.statusText);
//           setCompanyEmployees([]);
//         }
//       } catch (error) {
//         console.error('Error fetching company employees:', error);
//         setCompanyEmployees([]);
//       } finally {
//         setEmployeeLoading(false);
//       }
//     };

//     fetchCompanyEmployees();
//     fetchCompanyProjects();
//     fetchCustomStatuses();
//   }, []);

//   // ---------- Fetch company projects ----------
//   const fetchCompanyProjects = async () => {
//     try {
//       const token = localStorage.getItem('authToken');
//       if (!token) {
//         setProjectsLoading(false);
//         return;
//       }

//       const decodedToken = jwtDecode(token);
//       const COMPANY_ID = decodedToken.role === 'company' 
//         ? (decodedToken.companyId || decodedToken.id) 
//         : decodedToken.companyId;

//       console.log('Dashboard - Fetching projects for company:', COMPANY_ID);

//       const response = await fetch(`https://slateblue-mallard-430836.hostingersite.com/api/projectsmgnt`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       });

//       if (response.ok) {
//         const projectsData = await response.json();
//         // Filter projects by company ID
//         const allProjects = Array.isArray(projectsData) ? projectsData : projectsData.data || [];
//         console.log('Dashboard - All projects fetched:', allProjects.length);
//         console.log('Dashboard - Sample project structure:', allProjects[0]);

//         const filteredProjects = allProjects.filter(project => 
//           project.companyId === COMPANY_ID || project.company === COMPANY_ID
//         );
//         console.log('Dashboard - Filtered projects for company:', filteredProjects.length);
//         setCompanyProjects(filteredProjects);
//       } else {
//         console.error('Failed to fetch company projects:', response.status, response.statusText);
//         setCompanyProjects([]);
//       }
//     } catch (error) {
//       console.error('Error fetching company projects:', error);
//       setCompanyProjects([]);
//     } finally {
//       setProjectsLoading(false);
//     }
//   };

//   // ---------- Fetch custom statuses ----------
//   const fetchCustomStatuses = async () => {
//     try {
//       const token = localStorage.getItem('authToken');
//       const response = await fetch('https://slateblue-mallard-430836.hostingersite.com/api/prjCustomStatus/', {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         }
//       });

//       if (response.ok) {
//         const data = await response.json();
//         console.log('Dashboard - Custom statuses API response:', data);
//         console.log('Dashboard - Response type:', typeof data);
//         console.log('Dashboard - Is array:', Array.isArray(data));

//         // Handle different response formats
//         let statusArray = [];
//         if (Array.isArray(data)) {
//           statusArray = data;
//         } else if (data && Array.isArray(data.data)) {
//           statusArray = data.data;
//         } else if (data && typeof data === 'object') {
//           // If it's an object, try to extract status names
//           statusArray = Object.values(data).filter(item => typeof item === 'string');
//         }

//         console.log('Dashboard - Processed status array:', statusArray);
//         setStatusOptions(statusArray);
//       } else {
//         console.error('Failed to fetch custom statuses:', response.status, response.statusText);
//         setStatusOptions([]);
//       }
//     } catch (error) {
//       console.error('Error fetching custom statuses:', error);
//       setStatusOptions([]);
//     } finally {
//       setStatusLoading(false);
//     }
//   };

//   // Calculate progress based on status position in statusOptions array
//   const getStatusProgress = (currentStatus, statusOptions) => {
//     // Ensure statusOptions is an array
//     const statusArray = Array.isArray(statusOptions) ? statusOptions : [];

//     if (!statusArray || statusArray.length === 0) {
//       // Fallback to default statuses if no custom statuses available
//       const defaultStatuses = ['Planning', 'In Progress', 'Completed'];
//       const statusIndex = defaultStatuses.findIndex(status => 
//         status.toLowerCase() === (currentStatus || '').toLowerCase()
//       );
//       const currentPosition = statusIndex >= 0 ? statusIndex + 1 : 1;
//       return {
//         current: currentPosition,
//         total: defaultStatuses.length,
//         percentage: Math.round((currentPosition / defaultStatuses.length) * 100)
//       };
//     }

//     const statusIndex = statusArray.findIndex(status => 
//       status.toLowerCase() === (currentStatus || '').toLowerCase()
//     );
//     const currentPosition = statusIndex >= 0 ? statusIndex + 1 : 1;

//     return {
//       current: currentPosition,
//       total: statusArray.length,
//       percentage: Math.round((currentPosition / statusArray.length) * 100)
//     };
//   };

//   // Calculate overall progress based on all projects' status positions
//   const calculateOverallProgress = () => {
//     if (!companyProjects || companyProjects.length === 0) return 0;

//     try {
//       const totalProgress = companyProjects.reduce((sum, project) => {
//         if (!project) return sum;
//         const progressData = getStatusProgress(project.status, statusOptions);
//         return sum + (progressData ? progressData.percentage : 0);
//       }, 0);

//       return Math.round(totalProgress / companyProjects.length);
//     } catch (error) {
//       console.error('Error calculating overall progress:', error);
//       return 0;
//     }
//   };

//   // ---------- Stats Logic ----------
//   const getProjectStats = () => {
//     const total = companyProjects.length;
//     const completed = companyProjects.filter((p) => p.status === 'Completed').length;
//     const inProgress = companyProjects.filter((p) => p.status === 'In Progress').length;
//     const planning = companyProjects.filter((p) => p.status === 'Planning').length;
//     return { total, completed, inProgress, planning };
//   };

//   const getMilestoneStats = () => {
//     const ms = Array.isArray(milestones) ? milestones : [];
//     const total = ms.length;
//     const completed = ms.filter((m) => m.status === 'Completed').length;
//     const pending = ms.filter((m) => m.status === 'Pending').length;
//     return { total, completed, pending };
//   };

//   const getUpcomingDeadlines = () => {
//     const safeProjects = Array.isArray(companyProjects) ? companyProjects : [];

//     const today = new Date();
//     const upcomingItems = safeProjects
//       .filter((item) => {
//         const deadline = new Date(item.deadline || item.dueDate);
//         if (isNaN(deadline.getTime())) return false;
//         const daysUntil = Math.ceil((deadline - today) / (1000 * 60 * 60 * 24));
//         return daysUntil >= 0 && daysUntil <= 7;
//       })
//       .sort((a, b) => new Date(a.deadline || a.dueDate) - new Date(b.deadline || b.dueDate))
//       .slice(0, 5);

//     return upcomingItems;
//   };

//   // Handle project card click to navigate to ProjectView
//   const handleProjectClick = (project) => {
//     const projectId = project._id || project.id;
//     if (onNavigate) {
//       onNavigate(`/projects/${projectId}`, 'Project Details');
//     } else {
//       navigate(`/projects/${projectId}`);
//     }
//   };

//   // ---------- State Management ----------
//   const [hoveredCard, setHoveredCard] = useState(null);
//   const [hoveredAction, setHoveredAction] = useState(null);
//   const [hoveredDeadline, setHoveredDeadline] = useState(null);

//   const projectStats = getProjectStats();
//   const milestoneStats = getMilestoneStats();
//   const upcomingDeadlines = getUpcomingDeadlines();
//   const overallProgress = calculateOverallProgress();

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Header Section */}
//       <div className="bg-white border-b border-gray-200">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-1">
//           <div className="py-1">
//             <div className="flex items-center justify-between">
//               <div>
//                 <h1 className="text-3xl font-bold text-gray-900">Project Dashboard</h1>
//                 <p className="mt-2 text-lg text-gray-600">
//                   Welcome to your project management workspace
//                 </p>
//               </div>
//               <div className="flex items-center space-x-4">
//                 <div className="flex items-center space-x-1 text-amber-500">
//                   <Sparkles className="w-5 h-5" />
//                   <Star className="w-5 h-5" />
//                   <Zap className="w-5 h-5" />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Main Content */}
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//         {/* Stats Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
//           {/* Projects Card */}
//           <div 
//             className={`bg-white rounded-xl shadow-sm border border-gray-200 p-6 transition-all duration-200 ${
//               hoveredCard === 'projects' ? 'shadow-md transform -translate-y-1' : 'hover:shadow-md'
//             }`}
//             onMouseEnter={() => setHoveredCard('projects')}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <div className="flex items-center justify-between mb-4">
//               <div className="flex items-center space-x-3">
//                 <div className="p-3 bg-blue-50 rounded-lg">
//                   <FolderOpen className="w-6 h-6 text-blue-600" />
//                 </div>
//                 <h3 className="text-lg font-semibold text-gray-900">Projects</h3>
//               </div>
//               <button 
//                 onClick={() => onNavigate ? onNavigate('/projects', 'Projects') : navigate('/projects')}
//                 className="text-blue-600 hover:text-blue-700 transition-colors duration-200"
//               >
//                 <ArrowRight className="w-5 h-5" />
//               </button>
//             </div>

//             <div className="mb-4">
//               <div className="text-3xl font-bold text-gray-900 mb-2">
//                 {projectsLoading ? '...' : projectStats.total}
//               </div>
//               <div className="flex items-center space-x-4 text-sm text-gray-600">
//                 <span className="flex items-center space-x-1">
//                   <CheckCircle className="w-4 h-4 text-green-500" />
//                   <span>{projectsLoading ? '...' : projectStats.completed} completed</span>
//                 </span>
//                 <span className="flex items-center space-x-1">
//                   <Clock className="w-4 h-4 text-blue-500" />
//                   <span>{projectsLoading ? '...' : projectStats.inProgress} active</span>
//                 </span>
//               </div>
//             </div>

//             <div className="w-full bg-gray-200 rounded-full h-2">
//               <div 
//                 className="bg-blue-600 h-2 rounded-full transition-all duration-500"
//                 style={{ width: `${companyProjects.length > 0 ? overallProgress : 0}%` }}
//               ></div>
//             </div>
//           </div>

//           {/* Team Members Card */}
//           <div 
//             className={`bg-white rounded-xl shadow-sm border border-gray-200 p-6 transition-all duration-200 ${
//               hoveredCard === 'employees' ? 'shadow-md transform -translate-y-1' : 'hover:shadow-md'
//             }`}
//             onMouseEnter={() => setHoveredCard('employees')}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <div className="flex items-center justify-between mb-4">
//               <div className="flex items-center space-x-3">
//                 <div className="p-3 bg-green-50 rounded-lg">
//                   <Users className="w-6 h-6 text-green-600" />
//                 </div>
//                 <h3 className="text-lg font-semibold text-gray-900">Team Members</h3>
//               </div>
//               <button 
//                 onClick={() => onNavigate ? onNavigate('/employees', 'Employee Lists') : navigate('/employees')}
//                 className="text-green-600 hover:text-green-700 transition-colors duration-200"
//               >
//                 <ArrowRight className="w-5 h-5" />
//               </button>
//             </div>

//             <div className="mb-4">
//               <div className="text-3xl font-bold text-gray-900 mb-2">
//                 {employeeLoading ? '...' : companyEmployees.length}
//               </div>
//               <div className="text-sm text-gray-600">
//                 Active team members
//               </div>
//             </div>

//             <div className="w-full bg-gray-200 rounded-full h-2">
//               <div 
//                 className="bg-green-600 h-2 rounded-full transition-all duration-500"
//                 style={{ width: `${companyEmployees.length > 0 ? 100 : 0}%` }}
//               ></div>
//             </div>
//           </div>

//           {/* Progress Card */}
//           <div 
//             className={`bg-white rounded-xl shadow-sm border border-gray-200 p-6 transition-all duration-200 ${
//               hoveredCard === 'progress' ? 'shadow-md transform -translate-y-1' : 'hover:shadow-md'
//             }`}
//             onMouseEnter={() => setHoveredCard('progress')}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <div className="flex items-center justify-between mb-4">
//               <div className="flex items-center space-x-3">
//                 <div className="p-3 bg-purple-50 rounded-lg">
//                   <TrendingUp className="w-6 h-6 text-purple-600" />
//                 </div>
//                 <h3 className="text-lg font-semibold text-gray-900">Overall Progress</h3>
//               </div>
//               <button 
//                 onClick={() => onNavigate ? onNavigate('/reports', 'Reports') : navigate('/reports')}
//                 className="text-purple-600 hover:text-purple-700 transition-colors duration-200"
//               >
//                 <ArrowRight className="w-5 h-5" />
//               </button>
//             </div>

//             <div className="mb-4">
//               <div className="text-3xl font-bold text-gray-900 mb-2">
//                 {projectsLoading || statusLoading ? '...' : overallProgress}%
//               </div>
//               <div className="text-sm text-gray-600">
//                 Completion rate across all projects
//               </div>
//             </div>

//             <div className="w-full bg-gray-200 rounded-full h-2">
//               <div 
//                 className="bg-purple-600 h-2 rounded-full transition-all duration-500"
//                 style={{ width: `${overallProgress}%` }}
//               ></div>
//             </div>
//           </div>
//         </div>

//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
//           {/* Upcoming Deadlines Section */}
//           <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//             <div className="flex items-center justify-between mb-6">
//               <h2 className="text-xl font-semibold text-gray-900 flex items-center space-x-2">
//                 <Calendar className="w-5 h-5 text-gray-600" />
//                 <span>Upcoming Deadlines</span>
//               </h2>
//               <span className="text-sm text-gray-500">
//                 Next 7 days
//               </span>
//             </div>

//             <div className="space-y-4">
//               {upcomingDeadlines.length > 0 ? (
//                 upcomingDeadlines.map((item, idx) => {
//                   const deadline = new Date(item.deadline || item.dueDate);
//                   const today = new Date();
//                   const daysUntil = Math.ceil((deadline - today) / (1000 * 60 * 60 * 24));

//                   const getDeadlineStyle = () => {
//                     if (daysUntil <= 1) return 'border-red-200 bg-red-50';
//                     if (daysUntil <= 3) return 'border-amber-200 bg-amber-50';
//                     return 'border-blue-200 bg-blue-50';
//                   };

//                   const getIcon = () => {
//                     if (daysUntil <= 1) return <AlertTriangle className="w-4 h-4 text-red-500" />;
//                     if (daysUntil <= 3) return <Clock className="w-4 h-4 text-amber-500" />;
//                     return <Calendar className="w-4 h-4 text-blue-500" />;
//                   };

//                   return (
//                     <div
//                       key={`deadline-${idx}`}
//                       className={`p-4 rounded-lg border-2 cursor-pointer transition-all duration-200 ${
//                         getDeadlineStyle()
//                       } ${hoveredDeadline === idx ? 'transform -translate-y-1 shadow-md' : 'hover:shadow-sm'}`}
//                       onClick={() => handleProjectClick(item)}
//                       onMouseEnter={() => setHoveredDeadline(idx)}
//                       onMouseLeave={() => setHoveredDeadline(null)}
//                     >
//                       <div className="flex items-center justify-between">
//                         <div className="flex items-center space-x-3">
//                           {getIcon()}
//                           <div>
//                             <h4 className="font-medium text-gray-900 text-sm">
//                               {item.name || item.title}
//                             </h4>
//                             <p className="text-xs text-gray-600 mt-1">
//                               {daysUntil === 0
//                                 ? 'Due today'
//                                 : daysUntil === 1
//                                 ? 'Due tomorrow'
//                                 : `Due in ${daysUntil} days`}
//                             </p>
//                           </div>
//                         </div>
//                         <div className="text-right">
//                           <span className="text-xs font-medium text-gray-500 block">
//                             {deadline.toLocaleDateString()}
//                           </span>
//                           <span className="inline-block px-2 py-1 text-xs font-medium bg-blue-100 text-blue-800 rounded-full mt-1">
//                             Project
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })
//               ) : (
//                 <div className="text-center py-8">
//                   <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-3" />
//                   <p className="text-gray-600 font-medium">No upcoming deadlines in the next 7 days</p>
//                   <p className="text-sm text-gray-500 mt-1">All caught up!</p>
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Quick Actions Section */}
//           <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//             <div className="mb-6">
//               <h2 className="text-xl font-semibold text-gray-900 flex items-center space-x-2">
//                 <Zap className="w-5 h-5 text-gray-600" />
//                 <span>Quick Actions</span>
//               </h2>
//               <p className="text-sm text-gray-600 mt-1">
//                 Quickly access frequently used features
//               </p>
//             </div>

//             <div className="space-y-4">
//               <button
//                 onClick={() => onNavigate ? onNavigate('/projects/add', 'Add Project') : navigate('/projects/add')}
//                 className={`w-full flex items-center justify-between p-4 rounded-lg border-2 border-gray-200 bg-white hover:border-blue-500 hover:bg-blue-50 transition-all duration-200 ${
//                   hoveredAction === 'new-project' ? 'border-blue-500 bg-blue-50 transform -translate-y-1' : ''
//                 }`}
//                 onMouseEnter={() => setHoveredAction('new-project')}
//                 onMouseLeave={() => setHoveredAction(null)}
//               >
//                 <div className="flex items-center space-x-3">
//                   <div className="p-2 bg-blue-100 rounded-lg">
//                     <Plus className="w-5 h-5 text-blue-600" />
//                   </div>
//                   <div className="text-left">
//                     <div className="font-medium text-gray-900">Create New Project</div>
//                     <div className="text-sm text-gray-600">Start a new project</div>
//                   </div>
//                 </div>
//                 <ChevronRight className="w-5 h-5 text-gray-400" />
//               </button>

//               <button
//                 onClick={() => onNavigate ? onNavigate('/kanban', 'Project Tracker') : navigate('/kanban')}
//                 className={`w-full flex items-center justify-between p-4 rounded-lg border-2 border-gray-200 bg-white hover:border-green-500 hover:bg-green-50 transition-all duration-200 ${
//                   hoveredAction === 'tracker' ? 'border-green-500 bg-green-50 transform -translate-y-1' : ''
//                 }`}
//                 onMouseEnter={() => setHoveredAction('tracker')}
//                 onMouseLeave={() => setHoveredAction(null)}
//               >
//                 <div className="flex items-center space-x-3">
//                   <div className="p-2 bg-green-100 rounded-lg">
//                     <Activity className="w-5 h-5 text-green-600" />
//                   </div>
//                   <div className="text-left">
//                     <div className="font-medium text-gray-900">Project Tracker</div>
//                     <div className="text-sm text-gray-600">Kanban board view</div>
//                   </div>
//                 </div>
//                 <ChevronRight className="w-5 h-5 text-gray-400" />
//               </button>

//               <button
//                 onClick={() => onNavigate ? onNavigate('/reports', 'Reports') : navigate('/reports')}
//                 className="w-full flex items-center justify-between p-4 rounded-lg border-2 border-gray-200 bg-white hover:border-purple-500 hover:bg-purple-50 transition-all duration-200"
//               >
//                 <div className="flex items-center space-x-3">
//                   <div className="p-2 bg-purple-100 rounded-lg">
//                     <BarChart3 className="w-5 h-5 text-purple-600" />
//                   </div>
//                   <div className="text-left">
//                     <div className="font-medium text-gray-900">View Reports</div>
//                     <div className="text-sm text-gray-600">Analytics & insights</div>
//                   </div>
//                 </div>
//                 <ChevronRight className="w-5 h-5 text-gray-400" />
//               </button>

//               <button
//                 onClick={() => onNavigate ? onNavigate('/employees', 'Employees') : navigate('/employees')}
//                 className="w-full flex items-center justify-between p-4 rounded-lg border-2 border-gray-200 bg-white hover:border-orange-500 hover:bg-orange-50 transition-all duration-200"
//               >
//                 <div className="flex items-center space-x-3">
//                   <div className="p-2 bg-orange-100 rounded-lg">
//                     <Users className="w-5 h-5 text-orange-600" />
//                   </div>
//                   <div className="text-left">
//                     <div className="font-medium text-gray-900">Manage Team</div>
//                     <div className="text-sm text-gray-600">Team members</div>
//                   </div>
//                 </div>
//                 <ChevronRight className="w-5 h-5 text-gray-400" />
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Recent Activity Section (Placeholder for future enhancement) */}
//         <div className="mt-8 bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//           <div className="flex items-center justify-between mb-6">
//             <h2 className="text-xl font-semibold text-gray-900 flex items-center space-x-2">
//               <Target className="w-5 h-5 text-gray-600" />
//               <span>Recent Activity</span>
//             </h2>
//             <span className="text-sm text-gray-500">
//               Last 30 days
//             </span>
//           </div>
//           <div className="text-center py-8">
//             <div className="text-gray-400 mb-2">
//               <Activity className="w-12 h-12 mx-auto" />
//             </div>
//             <p className="text-gray-600 font-medium">Activity tracking coming soon</p>
//             <p className="text-sm text-gray-500 mt-1">Monitor project updates and team activity</p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;




// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { jwtDecode } from "jwt-decode";
// import {
//   FolderOpen,
//   Users,
//   Calendar,
//   CheckCircle,
//   Clock,
//   AlertTriangle,
//   TrendingUp,
//   Sparkles,
//   Zap,
//   Star,
//   Activity
// } from 'lucide-react';

// const Dashboard = ({ projects = [], employees = [], milestones = [], onNavigate }) => {
//   const navigate = useNavigate();

//   // ---------- State for company employees ----------
//   const [companyEmployees, setCompanyEmployees] = useState([]);
//   const [employeeLoading, setEmployeeLoading] = useState(true);

//   // ---------- State for company projects ----------
//   const [companyProjects, setCompanyProjects] = useState([]);
//   const [projectsLoading, setProjectsLoading] = useState(true);

//   // ---------- State for custom statuses ----------
//   const [statusOptions, setStatusOptions] = useState([]);
//   const [statusLoading, setStatusLoading] = useState(true);

//   // ---------- Fetch company employees ----------
//   useEffect(() => {
//     const fetchCompanyEmployees = async () => {
//       try {
//         const token = localStorage.getItem('authToken');
//         if (!token) {
//           setEmployeeLoading(false);
//           return;
//         }

//         const decodedToken = jwtDecode(token);
//         const COMPANY_ID = decodedToken.role === 'company' 
//           ? (decodedToken.companyId || decodedToken.id) 
//           : decodedToken.companyId;

//         const response = await fetch(`https://slateblue-mallard-430836.hostingersite.com/api/employees/company/${COMPANY_ID}`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json',
//           },
//         });

//         if (response.ok) {
//           const employeesData = await response.json();
//           setCompanyEmployees(Array.isArray(employeesData) ? employeesData.filter(emp => emp.isActive !== false) : (employeesData.data || []).filter(emp => emp.isActive !== false));
//         } else {
//           console.error('Failed to fetch company employees:', response.status, response.statusText);
//           setCompanyEmployees([]);
//         }
//       } catch (error) {
//         console.error('Error fetching company employees:', error);
//         setCompanyEmployees([]);
//       } finally {
//         setEmployeeLoading(false);
//       }
//     };

//     fetchCompanyEmployees();
//     fetchCompanyProjects();
//     fetchCustomStatuses();
//   }, []);

//   // ---------- Fetch company projects ----------
//   const fetchCompanyProjects = async () => {
//     try {
//       const token = localStorage.getItem('authToken');
//       if (!token) {
//         setProjectsLoading(false);
//         return;
//       }

//       const decodedToken = jwtDecode(token);
//       const COMPANY_ID = decodedToken.role === 'company' 
//         ? (decodedToken.companyId || decodedToken.id) 
//         : decodedToken.companyId;

//       console.log('Dashboard - Fetching projects for company:', COMPANY_ID);

//       const response = await fetch(`https://slateblue-mallard-430836.hostingersite.com/api/projectsmgnt`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       });

//       if (response.ok) {
//         const projectsData = await response.json();
//         // Filter projects by company ID
//         const allProjects = Array.isArray(projectsData) ? projectsData : projectsData.data || [];
//         console.log('Dashboard - All projects fetched:', allProjects.length);
//         console.log('Dashboard - Sample project structure:', allProjects[0]);

//         const filteredProjects = allProjects.filter(project => 
//           project.companyId === COMPANY_ID || project.company === COMPANY_ID
//         );
//         console.log('Dashboard - Filtered projects for company:', filteredProjects.length);
//         setCompanyProjects(filteredProjects);
//       } else {
//         console.error('Failed to fetch company projects:', response.status, response.statusText);
//         setCompanyProjects([]);
//       }
//     } catch (error) {
//       console.error('Error fetching company projects:', error);
//       setCompanyProjects([]);
//     } finally {
//       setProjectsLoading(false);
//     }
//   };

//   // ---------- Fetch custom statuses ----------
//   const fetchCustomStatuses = async () => {
//     try {
//       const token = localStorage.getItem('authToken');
//       const response = await fetch('https://slateblue-mallard-430836.hostingersite.com/api/prjCustomStatus/', {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         }
//       });

//       if (response.ok) {
//         const data = await response.json();
//         console.log('Dashboard - Custom statuses API response:', data);
//         console.log('Dashboard - Response type:', typeof data);
//         console.log('Dashboard - Is array:', Array.isArray(data));

//         // Handle different response formats
//         let statusArray = [];
//         if (Array.isArray(data)) {
//           statusArray = data;
//         } else if (data && Array.isArray(data.data)) {
//           statusArray = data.data;
//         } else if (data && typeof data === 'object') {
//           // If it's an object, try to extract status names
//           statusArray = Object.values(data).filter(item => typeof item === 'string');
//         }

//         console.log('Dashboard - Processed status array:', statusArray);
//         setStatusOptions(statusArray);
//       } else {
//         console.error('Failed to fetch custom statuses:', response.status, response.statusText);
//         setStatusOptions([]);
//       }
//     } catch (error) {
//       console.error('Error fetching custom statuses:', error);
//       setStatusOptions([]);
//     } finally {
//       setStatusLoading(false);
//     }
//   };

//   // Calculate progress based on status position in statusOptions array
//   const getStatusProgress = (currentStatus, statusOptions) => {
//     // Ensure statusOptions is an array
//     const statusArray = Array.isArray(statusOptions) ? statusOptions : [];

//     if (!statusArray || statusArray.length === 0) {
//       // Fallback to default statuses if no custom statuses available
//       const defaultStatuses = ['Planning', 'In Progress', 'Completed'];
//       const statusIndex = defaultStatuses.findIndex(status => 
//         status.toLowerCase() === (currentStatus || '').toLowerCase()
//       );
//       const currentPosition = statusIndex >= 0 ? statusIndex + 1 : 1;
//       return {
//         current: currentPosition,
//         total: defaultStatuses.length,
//         percentage: Math.round((currentPosition / defaultStatuses.length) * 100)
//       };
//     }

//     const statusIndex = statusArray.findIndex(status => 
//       status.toLowerCase() === (currentStatus || '').toLowerCase()
//     );
//     const currentPosition = statusIndex >= 0 ? statusIndex + 1 : 1;

//     return {
//       current: currentPosition,
//       total: statusArray.length,
//       percentage: Math.round((currentPosition / statusArray.length) * 100)
//     };
//   };

//   // Calculate overall progress based on all projects' status positions
//   const calculateOverallProgress = () => {
//     if (!companyProjects || companyProjects.length === 0) return 0;

//     try {
//       const totalProgress = companyProjects.reduce((sum, project) => {
//         if (!project) return sum;
//         const progressData = getStatusProgress(project.status, statusOptions);
//         return sum + (progressData ? progressData.percentage : 0);
//       }, 0);

//       return Math.round(totalProgress / companyProjects.length);
//     } catch (error) {
//       console.error('Error calculating overall progress:', error);
//       return 0;
//     }
//   };

//   // ---------- Modern Glassmorphism Styles ----------
//   const dashboardStyle = {
//     padding: '2rem',
//     fontFamily: '"Inter", "Segoe UI", Roboto, sans-serif',
//     backgroundColor: '#f8fafc',
//     minHeight: '100vh',
//     overflow: 'hidden',
//   };

//   const backgroundOverlayStyle = {
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     background: 'rgba(255, 255, 255, 0.1)',
//     backdropFilter: 'blur(20px)',
//     zIndex: 0,
//   };

//   const contentWrapperStyle = {
//     position: 'relative',
//     zIndex: 1,
//   };

//   const dashboardHeaderStyle = {
//     marginBottom: '3rem',
//     textAlign: 'center',
//     padding: '2rem',
//     background: 'rgba(255, 255, 255, 0.15)',
//     backdropFilter: 'blur(25px)',
//     borderRadius: '2rem',
//     border: '1px solid rgba(255, 255, 255, 0.2)',
//     boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.3)',
//     position: 'relative',
//     overflow: 'hidden',
//     animation: 'slideInDown 0.8s ease-out',
//   };

//   const headerTitleStyle = {
//     fontSize: '3rem',
//     fontWeight: 900,
//     marginBottom: '0.5rem',
//     color: '#1f2937',
//     position: 'relative',
//     zIndex: 2,
//     letterSpacing: '1px',
//   };

//   const headerSubtitleStyle = {
//     fontSize: '1.2rem',
//     fontWeight: 500,
//     position: 'relative',
//     zIndex: 2,
//     color: '#6b7280'
//   };

//   const headerIconsStyle = {
//     display: 'flex',
//     justifyContent: 'center',
//     gap: '1rem',
//     marginTop: '1.5rem',
//     position: 'relative',
//     zIndex: 2,
//   };

//   // ---------- CSS Keyframes ----------
//   const keyframesStyle = `
//     @keyframes gradientShift {
//       0% { background-position: 0% 50%; }
//       50% { background-position: 100% 50%; }
//       100% { background-position: 0% 50%; }
//     }

//     @keyframes slideInDown {
//       from {
//         opacity: 0;
//         transform: translateY(-30px);
//       }
//       to {
//         opacity: 1;
//         transform: translateY(0);
//       }
//     }

//     @keyframes fadeInUp {
//       from {
//         opacity: 0;
//         transform: translateY(30px);
//       }
//       to {
//         opacity: 1;
//         transform: translateY(0);
//       }
//     }

//     @keyframes cardSlideIn {
//       from {
//         opacity: 0;
//         transform: translateX(-20px) scale(0.95);
//       }
//       to {
//         opacity: 1;
//         transform: translateX(0) scale(1);
//       }
//     }

//     @keyframes rotate {
//       from { transform: rotate(0deg); }
//       to { transform: rotate(360deg); }
//     }

//     @keyframes pulse {
//       0%, 100% { transform: scale(1); }
//       50% { transform: scale(1.05); }
//     }

//     @keyframes progressGlow {
//       0% { box-shadow: 0 0 10px rgba(102, 126, 234, 0.6); }
//       100% { box-shadow: 0 0 20px rgba(102, 126, 234, 0.9), 0 0 30px rgba(240, 147, 251, 0.5); }
//     }
//   `;

//   // ---------- Grid ----------
//   const statsGridStyle = {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
//     gap: '2.5rem',
//     marginBottom: '3rem',
//     animation: 'fadeInUp 1s ease-out 0.3s both',
//   };

//   // ---------- Enhanced Card Base ----------
//   const recentActivityStyle = {
//     backgroundColor: 'white',
//     borderRadius: '0.5rem',
//     padding: '2rem',
//     border: '1px solid #e5e7eb',
//     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
//   };

//   const statCardStyle = {
//     backgroundColor: 'white',
//     borderRadius: '0.5rem',
//     padding: '2rem',
//     border: '1px solid #e5e7eb',
//     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
//     position: 'relative',
//     zIndex: 2,
//   };

//   const statCardHoverStyle = {
//     transform: 'translateY(-2px)',
//     boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
//   };


//   const statIconStyle = {
//     display: 'inline-flex',
//     padding: '1.2rem',
//     backgroundColor: '#3b82f6',
//     borderRadius: '0.5rem',
//     marginBottom: '1.5rem',
//     color: 'white',
//     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
//     border: '1px solid #2563eb',
//     position: 'relative',
//     zIndex: 2,
//   };

//   const statNumberStyle = {
//     fontSize: '2.5rem',
//     fontWeight: 900,
//     color: '#1f2937',
//     marginBottom: '0.75rem',
//     position: 'relative',
//     zIndex: 2,
//   };

//   const statTitleStyle = {
//     fontSize: '1.2rem',
//     fontWeight: 700,
//     color: '#1f2937',
//     marginBottom: '1rem',
//     position: 'relative',
//     zIndex: 2,
//   };

//   const statBreakdownStyle = {
//     display: 'flex',
//     gap: '1.5rem',
//     fontSize: '0.9rem',
//     color: '#6b7280',
//     position: 'relative',
//     zIndex: 2,
//   };

//   const statLinkStyle = {
//     position: 'absolute',
//     top: '1.5rem',
//     right: '1.5rem',
//     color: '#3b82f6',
//     textDecoration: 'none',
//     fontSize: '0.9rem',
//     fontWeight: 600,
//     transition: 'all 0.3s ease',
//     backgroundColor: '#f3f4f6',
//     padding: '0.5rem 1rem',
//     borderRadius: '0.5rem',
//     border: '1px solid #d1d5db',
//     position: 'absolute',
//     zIndex: 2,
//   };

//   const statLinkHoverStyle = {
//     backgroundColor: '#e5e7eb',
//     color: '#1f2937',
//     transform: 'scale(1.05)',
//   };

//   // ---------- Section Titles ----------
//   const sectionTitleStyle = {
//     fontSize: '1.6rem',
//     fontWeight: 800,
//     color: '#1f2937',
//     margin: 0,
//     position: 'relative',
//     zIndex: 2,
//     marginBottom: '2rem',
//   };

//   // ---------- Enhanced Quick Actions ----------
//   const quickActionsStyle = {
//     backgroundColor: 'white',
//     borderRadius: '0.5rem',
//     padding: '2rem',
//     border: '1px solid #e5e7eb',
//     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
//     marginBottom: '2rem',
//     position: 'relative',
//     zIndex: 2,
//   };

//   const actionButtonsStyle = {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
//     gap: '1.5rem',
//     marginTop: '2rem',
//   };

//   const actionBtnBase = {
//     display: 'inline-flex',
//     alignItems: 'center',
//     padding: '1.2rem 1.5rem',
//     borderRadius: '0.5rem',
//     fontWeight: 700,
//     fontSize: '1rem',
//     textDecoration: 'none',
//     cursor: 'pointer',
//     transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
//     gap: '0.75rem',
//     justifyContent: 'center',
//     border: '1px solid #d1d5db',
//     position: 'relative',
//     overflow: 'hidden',
//   };

//   const primaryActionStyle = {
//     ...actionBtnBase,
//     backgroundColor: '#3b82f6',
//     color: 'white',
//     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
//     border: '1px solid #2563eb',
//   };

//   const secondaryActionStyle = {
//     ...actionBtnBase,
//     backgroundColor: '#10b981',
//     color: 'white',
//     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
//     border: '1px solid #059669',
//   };

//   const actionHoverStyle = {
//     transform: 'translateY(-5px) scale(1.05)',
//     boxShadow: '0 20px 40px rgba(0, 0, 0, 0.2)',
//   };

//   // ---------- Enhanced Deadlines ----------
//   const deadlinesContainerStyle = {
//     backgroundColor: 'white',
//     borderRadius: '0.5rem',
//     padding: '2rem',
//     border: '1px solid #e5e7eb',
//     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
//     marginBottom: '3rem',
//     position: 'relative',
//     overflow: 'hidden',
//   };

//   const deadlineItemStyle = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     padding: '1rem',
//     borderRadius: '0.5rem',
//     marginBottom: '0.75rem',
//     backgroundColor: '#f9fafb',
//     border: '1px solid #e5e7eb',
//     transition: 'all 0.3s ease',
//   };

//   const deadlineItemHoverStyle = {
//     backgroundColor: 'white',
//     transform: 'translateX(5px)',
//     boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
//   };

//   const progressBarContainerStyle = {
//     width: '100%',
//     height: '8px',
//     backgroundColor: '#e5e7eb',
//     borderRadius: '0.5rem',
//     overflow: 'hidden',
//     marginTop: '1rem',
//     position: 'relative',
//     boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.05)',
//   };

//   const progressBarStyle = {
//     height: '100%',
//     backgroundColor: '#3b82f6',
//     borderRadius: '0.5rem',
//     transition: 'width 0.8s ease-out',
//   };

//   // ---------- Stats Logic ----------
//   const getProjectStats = () => {
//     const total = companyProjects.length;
//     const completed = companyProjects.filter((p) => p.status === 'Completed').length;
//     const inProgress = companyProjects.filter((p) => p.status === 'In Progress').length;
//     const planning = companyProjects.filter((p) => p.status === 'Planning').length;
//     return { total, completed, inProgress, planning };
//   };
//   const getMilestoneStats = () => {
//     const ms = Array.isArray(milestones) ? milestones : [];
//     const total = ms.length;
//     const completed = ms.filter((m) => m.status === 'Completed').length;
//     const pending = ms.filter((m) => m.status === 'Pending').length;
//     return { total, completed, pending };
//   };


//   const getUpcomingDeadlines = () => {
//     // Only include projects, exclude project-tasks/milestones
//     const safeProjects = Array.isArray(companyProjects) ? companyProjects : [];

//     const today = new Date();
//     const upcomingItems = safeProjects
//       .filter((item) => {
//         const deadline = new Date(item.deadline || item.dueDate);
//         if (isNaN(deadline.getTime())) return false;
//         const daysUntil = Math.ceil((deadline - today) / (1000 * 60 * 60 * 24));
//         return daysUntil >= 0 && daysUntil <= 7;
//       })
//       .sort((a, b) => new Date(a.deadline || a.dueDate) - new Date(b.deadline || b.dueDate))
//       .slice(0, 5);

//     return upcomingItems;
//   };

//   // Handle project card click to navigate to ProjectView
//   const handleProjectClick = (project) => {
//     const projectId = project._id || project.id;
//     if (onNavigate) {
//       onNavigate(`/projects/${projectId}`, 'Project Details');
//     } else {
//       navigate(`/projects/${projectId}`);
//     }
//   };

//   // ---------- State Management ----------
//   const [hoveredCard, setHoveredCard] = useState(null);
//   const [hoveredAction, setHoveredAction] = useState(null);
//   const [hoveredDeadline, setHoveredDeadline] = useState(null);

//   const projectStats = getProjectStats();
//   const milestoneStats = getMilestoneStats();
//   const upcomingDeadlines = getUpcomingDeadlines();

//   return (
//     <>

//       <style>{keyframesStyle}</style>
//       <div style={dashboardStyle}>
//         <div style={backgroundOverlayStyle}></div>
//         <div style={contentWrapperStyle}>
//           {/* Modern Glassmorphism Header */}
//           <div style={dashboardHeaderStyle}>
//             <h1 style={headerTitleStyle}>✅ Project Dashboard</h1>
//             <p style={headerSubtitleStyle}>Your personalized overview of projects and teams</p>
//             <div style={headerIconsStyle}>
//               <Sparkles size={24} style={{ animation: 'pulse 2s ease-in-out infinite' }} />
//               <Star size={24} style={{ animation: 'pulse 2s ease-in-out infinite 0.5s' }} />
//               <Zap size={24} style={{ animation: 'pulse 2s ease-in-out infinite 1s' }} />
//             </div>
//           </div>

//           {/* Enhanced Stats Cards */}
//           <div style={statsGridStyle}>
//             {/* Projects Card */}
//             <div
//               style={{
//                 ...statCardStyle,
//                 ...(hoveredCard === 'projects' ? statCardHoverStyle : {}),
//                 transition: 'all 0.2s ease',
//               }}
//               onMouseEnter={() => setHoveredCard('projects')}
//               onMouseLeave={() => setHoveredCard(null)}
//             >
//               <div style={statIconStyle}><FolderOpen size={28} /></div>
//               <h3 style={statTitleStyle}>Projects</h3>
//               <div style={statNumberStyle}>
//                 {projectsLoading ? '...' : projectStats.total}
//               </div>
//               <div style={statBreakdownStyle}>
//                 <span>✅ {projectsLoading ? '...' : projectStats.completed} completed</span>
//                 <span>🚀 {projectsLoading ? '...' : projectStats.inProgress} active</span>
//               </div>
//               <div style={progressBarContainerStyle}>
//                 <div 
//                   style={{
//                     ...progressBarStyle,
//                     width: `${companyProjects.length > 0 ? calculateOverallProgress() : 0}%`,
//                   }}
//                 ></div>
//               </div>
//               <button 
//                 onClick={() => onNavigate ? onNavigate('/projects', 'Projects') : navigate('/projects')}
//                 style={{
//                   ...statLinkStyle,
//                   ...(hoveredCard === 'projects' ? statLinkHoverStyle : {}),
//                   border: 'none',
//                   background: 'none',
//                   cursor: 'pointer'
//                 }}
//               >
//                 View All
//               </button>
//             </div>


//             {/* Employees Card */}

//             <div
//               style={{
//                 ...statCardStyle,
//                 ...(hoveredCard === 'employees' ? statCardHoverStyle : {}),
//                 transition: 'all 0.2s ease',
//               }}
//               onMouseEnter={() => setHoveredCard('employees')}
//               onMouseLeave={() => setHoveredCard(null)}
//             >
//               <div style={statIconStyle}><Users size={28} /></div>
//               <h3 style={statTitleStyle}>Team Members</h3>
//               <div style={statNumberStyle}>
//                 {employeeLoading ? '...' : companyEmployees.length}
//               </div>
//               <div style={statBreakdownStyle}>
//                 <span>👥 {employeeLoading ? 'Loading...' : `${companyEmployees.length} company members`}</span>
//               </div>
//               <div style={progressBarContainerStyle}>
//                 <div 
//                   style={{
//                     ...progressBarStyle,
//                     width: `${companyEmployees.length > 0 ? 100 : 0}%`,
//                   }}
//                 ></div>
//               </div>
//               <button 
//                 onClick={() => onNavigate ? onNavigate('/employees', 'Employee Lists') : navigate('/employees')}
//                 style={{
//                   ...statLinkStyle,
//                   ...(hoveredCard === 'employees' ? statLinkHoverStyle : {}),
//                   border: 'none',
//                   background: 'none',
//                   cursor: 'pointer'
//                 }}
//               >
//                 View All
//               </button>
//             </div>

//             {/* Progress Card */}
//             <div
//               style={{
//                 ...statCardStyle,
//                 ...(hoveredCard === 'progress' ? statCardHoverStyle : {}),
//                 transition: 'all 0.2s ease',
//               }}
//               onMouseEnter={() => setHoveredCard('progress')}
//               onMouseLeave={() => setHoveredCard(null)}
//             >
//               <div style={statIconStyle}><TrendingUp size={28} /></div>
//               <h3 style={statTitleStyle}>Overall Progress</h3>
//               <div style={statNumberStyle}>
//                 {projectsLoading || statusLoading ? '...' : 
//                   companyProjects.length > 0
//                     ? calculateOverallProgress()
//                     : 0}%
//               </div>
//               <div style={statBreakdownStyle}>
//                 <span>📊 Completion Rate</span>
//               </div>
//               <div style={progressBarContainerStyle}>
//                 <div 
//                   style={{
//                     ...progressBarStyle,
//                     width: `${companyProjects.length > 0 ? calculateOverallProgress() : 0}%`,
//                   }}
//                 ></div>
//               </div>
//               <button 
//                 onClick={() => onNavigate ? onNavigate('/reports', 'Reports') : navigate('/reports')}
//                 style={{
//                   ...statLinkStyle,
//                   ...(hoveredCard === 'progress' ? statLinkHoverStyle : {}),
//                   border: 'none',
//                   background: 'none',
//                   cursor: 'pointer'
//                 }}
//               >
//                 View All
//               </button>
//             </div>
//           </div>

//           {/* Enhanced Upcoming Deadlines */}
//           <div style={{...deadlinesContainerStyle, marginBottom: '2rem'}}>
//             <h2 style={sectionTitleStyle}>… Upcoming Deadlines</h2>
//             {upcomingDeadlines.length > 0 ? (
//               upcomingDeadlines.map((item, idx) => {
//                 const deadline = new Date(item.deadline || item.dueDate);
//                 const today = new Date();
//                 const daysUntil = Math.ceil((deadline - today) / (1000 * 60 * 60 * 24));

//                 return (
//                   <div
//                     key={`deadline-${idx}`}
//                     style={{
//                       backgroundColor: 'white',
//                       borderRadius: '1rem',
//                       padding: '1.5rem',
//                       marginBottom: '1rem',
//                       border: '1px solid #e5e7eb',
//                       boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//                       transition: 'all 0.3s ease',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'space-between',
//                       minHeight: '80px',
//                       cursor: 'pointer',
//                       ...(hoveredDeadline === idx ? { transform: 'translateY(-4px)', boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)' } : {}),
//                     }}
//                     onClick={() => handleProjectClick(item)}
//                     onMouseEnter={() => setHoveredDeadline(idx)}
//                     onMouseLeave={() => setHoveredDeadline(null)}
//                   >
//                     <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
//                       {daysUntil <= 1 ? (
//                         <AlertTriangle size={20} color="#dc2626" />
//                       ) : daysUntil <= 3 ? (
//                         <Clock size={20} color="#f59e0b" />
//                       ) : (
//                         <Calendar size={20} color="#3b82f6" />
//                       )}
//                       <div style={{ flex: 1 }}>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
//                           <h4 style={{ 
//                             margin: 0, 
//                             fontSize: '0.95rem', 
//                             fontWeight: 600, 
//                             color: '#1f2937',
//                           }}>
//                             {item.name || item.title}
//                           </h4>
//                           <span style={{
//                             padding: '0.125rem 0.375rem',
//                             borderRadius: '9999px',
//                             fontSize: '0.5rem',
//                             fontWeight: 500,
//                             textTransform: 'uppercase',
//                             backgroundColor: '#dbeafe',
//                             color: '#1e40af'
//                           }}>
//                             PROJECT
//                           </span>
//                         </div>
//                         <p style={{ 
//                           margin: 0, 
//                           fontSize: '0.75rem', 
//                           color: '#6b7280',
//                         }}>
//                           {daysUntil === 0
//                             ? 'Due today'
//                             : daysUntil === 1
//                             ? 'Due tomorrow'
//                             : `Due in ${daysUntil} days`}
//                         </p>
//                       </div>
//                     </div>
//                     <span style={{ 
//                       fontSize: '0.75rem', 
//                       color: '#9ca3af',
//                       fontWeight: 500,
//                     }}>
//                       {deadline.toLocaleDateString()}
//                     </span>
//                   </div>
//                 );
//               })
//             ) : (
//               <div style={{ 
//                 textAlign: 'center', 
//                 padding: '2rem', 
//                 color: 'rgba(255, 255, 255, 0.8)',
//               }}>
//                 <CheckCircle size={48} color="#6bcf7f" style={{ marginBottom: '1rem' }} />
//                 <p style={{ fontSize: '1.1rem', fontWeight: 600, margin: 0 }}>
//                   🎉 No upcoming deadlines in the next 7 days
//                 </p>
//               </div>
//             )}
//           </div>

//           {/* Enhanced Quick Actions */}
//           <div style={quickActionsStyle}>
//             <h2 style={sectionTitleStyle}>🚀 Quick Actions</h2>
//             <div style={actionButtonsStyle}>
//               <button
//                 onClick={() => onNavigate ? onNavigate('/add-project', 'Add Project') : navigate('/add-project')}
//                 style={{
//                   ...primaryActionStyle,
//                   ...(hoveredAction === 'new-project' ? actionHoverStyle : {}),
//                   border: 'none',
//                   cursor: 'pointer'
//                 }}
//                 onMouseEnter={() => setHoveredAction('new-project')}
//                 onMouseLeave={() => setHoveredAction(null)}
//               >
//                 <FolderOpen size={24} />
//                 Create New Project
//               </button>

//               <button
//                 onClick={() => onNavigate ? onNavigate('/kanban', 'Project Tracker') : navigate('/kanban')}
//                 style={{
//                   ...secondaryActionStyle,
//                   ...(hoveredAction === 'tracker' ? actionHoverStyle : {}),
//                   border: 'none',
//                   cursor: 'pointer'
//                 }}
//                 onMouseEnter={() => setHoveredAction('tracker')}
//                 onMouseLeave={() => setHoveredAction(null)}
//               >
//                 <Activity size={24} />
//                 Project Tracker
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Dashboard;



import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import {
  FolderOpen,
  Users,
  Calendar,
  CheckCircle,
  Clock,
  AlertTriangle,
  TrendingUp,
  Sparkles,
  Zap,
  Star,
  Activity,
  Plus,
  Target,
  BarChart3,
  ChevronRight
} from 'lucide-react';

const Dashboard = ({ projects = [], employees = [], milestones = [], onNavigate }) => {
  const navigate = useNavigate();

  // ---------- State for company employees ----------
  const [companyEmployees, setCompanyEmployees] = useState([]);
  const [employeeLoading, setEmployeeLoading] = useState(true);

  // ---------- State for company projects ----------
  const [companyProjects, setCompanyProjects] = useState([]);
  const [projectsLoading, setProjectsLoading] = useState(true);

  // ---------- State for custom statuses ----------
  const [statusOptions, setStatusOptions] = useState([]);
  const [statusLoading, setStatusLoading] = useState(true);

  // ---------- Fetch company employees ----------
  useEffect(() => {
    const fetchCompanyEmployees = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) {
          setEmployeeLoading(false);
          return;
        }

        const decodedToken = jwtDecode(token);
        const COMPANY_ID = decodedToken.role === 'company'
          ? (decodedToken.companyId || decodedToken.id)
          : decodedToken.companyId;

        const response = await fetch(`https://slateblue-mallard-430836.hostingersite.com/api/employees/company/${COMPANY_ID}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (response.ok) {
          const employeesData = await response.json();
          setCompanyEmployees(Array.isArray(employeesData) ? employeesData.filter(emp => emp.isActive !== false) : (employeesData.data || []).filter(emp => emp.isActive !== false));
        } else {
          console.error('Failed to fetch company employees:', response.status, response.statusText);
          setCompanyEmployees([]);
        }
      } catch (error) {
        console.error('Error fetching company employees:', error);
        setCompanyEmployees([]);
      } finally {
        setEmployeeLoading(false);
      }
    };

    fetchCompanyEmployees();
    fetchCompanyProjects();
    fetchCustomStatuses();
  }, []);

  // ---------- Fetch company projects ----------
  const fetchCompanyProjects = async () => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        setProjectsLoading(false);
        return;
      }

      const decodedToken = jwtDecode(token);
      const userRole = decodedToken.role;
      const userId = decodedToken.id || decodedToken._id;
      const COMPANY_ID = decodedToken.role === 'company'
        ? (decodedToken.companyId || decodedToken.id)
        : decodedToken.companyId;

      console.log('Dashboard - Fetching projects for company:', COMPANY_ID);
      console.log('Dashboard - User role:', userRole, 'User ID:', userId);

      const response = await fetch(`https://slateblue-mallard-430836.hostingersite.com/api/projectsmgnt`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const projectsData = await response.json();
        // Filter projects by company ID
        let allProjects = Array.isArray(projectsData) ? projectsData : projectsData.data || [];
        console.log('Dashboard - All projects fetched:', allProjects.length);
        console.log('Dashboard - Sample project structure:', allProjects[0]);

        let filteredProjects = allProjects.filter(project =>
          project.companyId === COMPANY_ID || project.company === COMPANY_ID
        );
        console.log('Dashboard - Filtered projects for company:', filteredProjects.length);

        // Further filter for team members
        if (userRole === 'employee' || userRole === 'team_member') {
          filteredProjects = filteredProjects.filter(project => {
            const isTeamMember = project.teamMembers && Array.isArray(project.teamMembers) &&
              project.teamMembers.some(member => {
                const memberId = typeof member === 'object' ? (member._id || member.id) : member;
                return String(memberId) === String(userId);
              });

            console.log(`Dashboard - Project "${project.title || project.name}" - isTeamMember:`, isTeamMember);
            return isTeamMember;
          });

          console.log('Dashboard - Filtered projects for team member:', filteredProjects.length);
        }

        setCompanyProjects(filteredProjects);
      } else {
        console.error('Failed to fetch company projects:', response.status, response.statusText);
        setCompanyProjects([]);
      }
    } catch (error) {
      console.error('Error fetching company projects:', error);
      setCompanyProjects([]);
    } finally {
      setProjectsLoading(false);
    }
  };

  // ---------- Fetch custom statuses ----------
  const fetchCustomStatuses = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch('https://slateblue-mallard-430836.hostingersite.com/api/prjCustomStatus/', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        console.log('Dashboard - Custom statuses API response:', data);
        console.log('Dashboard - Response type:', typeof data);
        console.log('Dashboard - Is array:', Array.isArray(data));

        // Handle different response formats
        let statusArray = [];
        if (Array.isArray(data)) {
          statusArray = data;
        } else if (data && Array.isArray(data.data)) {
          statusArray = data.data;
        } else if (data && typeof data === 'object') {
          // If it's an object, try to extract status names
          statusArray = Object.values(data).filter(item => typeof item === 'string');
        }

        console.log('Dashboard - Processed status array:', statusArray);
        setStatusOptions(statusArray);
      } else {
        console.error('Failed to fetch custom statuses:', response.status, response.statusText);
        setStatusOptions([]);
      }
    } catch (error) {
      console.error('Error fetching custom statuses:', error);
      setStatusOptions([]);
    } finally {
      setStatusLoading(false);
    }
  };

  // Calculate progress based on status position in statusOptions array
  const getStatusProgress = (currentStatus, statusOptions) => {
    // Ensure statusOptions is an array
    const statusArray = Array.isArray(statusOptions) ? statusOptions : [];

    if (!statusArray || statusArray.length === 0) {
      // Fallback to default statuses if no custom statuses available
      const defaultStatuses = ['Planning', 'In Progress', 'Completed'];
      const statusIndex = defaultStatuses.findIndex(status =>
        status.toLowerCase() === (currentStatus || '').toLowerCase()
      );
      const currentPosition = statusIndex >= 0 ? statusIndex + 1 : 1;
      return {
        current: currentPosition,
        total: defaultStatuses.length,
        percentage: Math.round((currentPosition / defaultStatuses.length) * 100)
      };
    }

    const statusIndex = statusArray.findIndex(status =>
      status.toLowerCase() === (currentStatus || '').toLowerCase()
    );
    const currentPosition = statusIndex >= 0 ? statusIndex + 1 : 1;

    return {
      current: currentPosition,
      total: statusArray.length,
      percentage: Math.round((currentPosition / statusArray.length) * 100)
    };
  };

  // Calculate overall progress based on all projects' status positions
  const calculateOverallProgress = () => {
    if (!companyProjects || companyProjects.length === 0) return 0;

    try {
      const totalProgress = companyProjects.reduce((sum, project) => {
        if (!project) return sum;
        const progressData = getStatusProgress(project.status, statusOptions);
        return sum + (progressData ? progressData.percentage : 0);
      }, 0);

      return Math.round(totalProgress / companyProjects.length);
    } catch (error) {
      console.error('Error calculating overall progress:', error);
      return 0;
    }
  };

  // ---------- Stats Logic ----------
  const getProjectStats = () => {
    const total = companyProjects.length;
    const completed = companyProjects.filter((p) => p.status === 'Completed').length;
    const inProgress = companyProjects.filter((p) => p.status === 'In Progress').length;
    const planning = companyProjects.filter((p) => p.status === 'Planning').length;
    return { total, completed, inProgress, planning };
  };

  const getMilestoneStats = () => {
    const ms = Array.isArray(milestones) ? milestones : [];
    const total = ms.length;
    const completed = ms.filter((m) => m.status === 'Completed').length;
    const pending = ms.filter((m) => m.status === 'Pending').length;
    return { total, completed, pending };
  };

  const getUpcomingDeadlines = () => {
    const safeProjects = Array.isArray(companyProjects) ? companyProjects : [];

    const today = new Date();
    const upcomingItems = safeProjects
      .filter((item) => {
        const deadline = new Date(item.deadline || item.dueDate);
        if (isNaN(deadline.getTime())) return false;
        const daysUntil = Math.ceil((deadline - today) / (1000 * 60 * 60 * 24));
        return daysUntil >= 0 && daysUntil <= 7;
      })
      .sort((a, b) => new Date(a.deadline || a.dueDate) - new Date(b.deadline || b.dueDate))
      .slice(0, 5);

    return upcomingItems;
  };

  // Handle project card click to navigate to ProjectView
  const handleProjectClick = (project) => {
    const projectId = project._id || project.id;
    if (onNavigate) {
      onNavigate(`/projects/${projectId}`, 'Project Details');
    } else {
      navigate(`/projects/${projectId}`);
    }
  };

  // ---------- State Management ----------
  const [hoveredCard, setHoveredCard] = useState(null);
  const [hoveredAction, setHoveredAction] = useState(null);
  const [hoveredDeadline, setHoveredDeadline] = useState(null);

  const projectStats = getProjectStats();
  const milestoneStats = getMilestoneStats();
  const upcomingDeadlines = getUpcomingDeadlines();
  const overallProgress = calculateOverallProgress();

  return (
    <div className="min-h-screen bg-gray-50">
      <style>{`
        @media (max-width: 768px) {
          /* Stats Grid container */
          #project-stats-grid {
            display: grid !important;
            grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
            gap: 0.4rem !important;
            margin-bottom: 1rem !important;
          }

          /* Individual Stat Cards */
          #project-stats-grid > button {
            padding: 0.5rem 0.35rem !important;
            border-radius: 12px !important;
            min-height: 90px !important;
            display: flex !important;
            flex-direction: column !important;
            align-items: flex-start !important;
            justify-content: space-between !important;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04) !important;
            border: 1px solid rgba(226, 232, 240, 0.8) !important;
          }

          /* Headers in Stat Cards */
          #project-stats-grid > button h3 {
            font-size: 0.62rem !important;
            font-weight: 700 !important;
            color: #475569 !important;
            margin-top: 0.15rem !important;
          }

          /* Number/Values in Stat Cards */
          #project-stats-grid > button .text-3xl {
            font-size: 1.25rem !important;
            font-weight: 800 !important;
            margin-top: 0.15rem !important;
            margin-bottom: 0.1rem !important;
            color: #0f172a !important;
          }

          /* Hide details & progress bar */
          #project-stats-grid > button > div:nth-child(2) > div:nth-child(2) {
            display: none !important;
          }
          #project-stats-grid > button .w-full.bg-gray-200 {
            height: 2.5px !important;
            margin-top: auto !important;
          }

          /* Icons and Title Layout inside Stats Card */
          .mobile-stat-header {
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 0.25rem !important;
          }
          .mobile-stat-icon-wrapper {
            padding: 0.25rem !important;
            border-radius: 6px !important;
          }
          .mobile-stat-icon-wrapper svg {
            width: 1rem !important;
            height: 1rem !important;
          }

          /* Details Section Grid */
          #project-details-grid {
            display: flex !important;
            flex-direction: column !important;
            gap: 0.75rem !important;
          }

          /* Detail Cards (Deadlines & Quick Actions) */
          #project-details-grid > div {
            padding: 1rem !important;
            border-radius: 16px !important;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02) !important;
          }

          /* Header titles */
          #project-details-grid h2 {
            font-size: 1.05rem !important;
            font-weight: 800 !important;
            margin-bottom: 0.75rem !important;
          }

          #project-details-grid h2 svg {
            width: 1.2rem !important;
            height: 1.2rem !important;
          }

          /* Deadline Items */
          #project-details-grid .space-y-4 > div {
            padding: 0.65rem 0.75rem !important;
            border-radius: 10px !important;
            margin-bottom: 0.5rem !important;
            border-width: 1px !important;
          }

          #project-details-grid .space-y-4 h4 {
            font-size: 0.82rem !important;
            font-weight: 700 !important;
          }

          #project-details-grid .space-y-4 p {
            font-size: 0.7rem !important;
            margin-top: 0.1rem !important;
          }

          #project-details-grid .space-y-4 .text-right {
            font-size: 0.7rem !important;
          }

          #project-details-grid .space-y-4 .text-right span.block {
            font-size: 0.7rem !important;
            margin-bottom: 0.1rem !important;
          }

          #project-details-grid .space-y-4 .text-right span.inline-flex {
            font-size: 0.55rem !important;
            padding: 0.1rem 0.35rem !important;
          }

          /* Quick Action Rows */
          #project-details-grid .space-y-3 > button {
            padding: 0.65rem 0.75rem !important;
            border-radius: 10px !important;
          }

          #project-details-grid .space-y-3 > button .p-2.5 {
            padding: 0.35rem !important;
            border-radius: 8px !important;
          }

          #project-details-grid .space-y-3 > button svg {
            width: 1.1rem !important;
            height: 1.1rem !important;
          }

          #project-details-grid .space-y-3 > button .text-slate-800 {
            font-size: 0.85rem !important;
            font-weight: 700 !important;
          }

          #project-details-grid .space-y-3 > button .text-xs {
            font-size: 0.7rem !important;
            margin-top: 0.05rem !important;
          }

          /* Recent Activity Card */
          #project-activity-card {
            padding: 1rem !important;
            border-radius: 16px !important;
            margin-top: 0.75rem !important;
          }

          #project-activity-card h2 {
            font-size: 1.05rem !important;
            font-weight: 800 !important;
            margin-bottom: 0.75rem !important;
          }

          #project-activity-card h2 svg {
            width: 1.2rem !important;
            height: 1.2rem !important;
          }

          #project-activity-card .text-center {
            padding: 1.25rem !important;
          }

          #project-activity-card .text-center svg {
            width: 2.2rem !important;
            height: 2.2rem !important;
          }

          #project-activity-card .text-center p.text-[15px] {
            font-size: 0.85rem !important;
            font-weight: 700 !important;
          }

          #project-activity-card .text-center p.text-xs {
            font-size: 0.72rem !important;
          }
        }
      `}</style>
      {/* Main Content */}
      <div className="max-w-[98%] mx-auto px-2 sm:px-4 lg:px-4 py-4 md:py-6">
        {/* Stats Grid */}
        <div id="project-stats-grid" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-6 md:mb-8">
          {/* Projects Card */}
          <button
            onClick={() => onNavigate ? onNavigate('/projects', 'Projects') : navigate('/projects')}
            className={`bg-gradient-to-br from-white to-slate-50 md:bg-white md:bg-none rounded-2xl md:rounded-xl shadow-md md:shadow-sm border border-gray-200/60 md:border-gray-200 p-5 md:p-4 transition-all duration-300 md:duration-200 cursor-pointer text-left ${hoveredCard === 'projects' ? 'md:shadow-md md:transform md:-translate-y-1' : 'md:hover:shadow-md'
              }`}
            onMouseEnter={() => setHoveredCard('projects')}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <div className="flex items-center mb-3 md:mb-2">
              <div className="flex items-center space-x-3 md:space-x-2 mobile-stat-header">
                <div className="p-2.5 md:p-2 bg-blue-100 md:bg-blue-50 rounded-xl md:rounded-lg shadow-inner md:shadow-none mobile-stat-icon-wrapper">
                  <FolderOpen className="w-6 h-6 md:w-5 md:h-5 text-blue-700 md:text-blue-600" />
                </div>
                <h3 className="text-base md:text-sm font-bold md:font-semibold text-slate-800 md:text-gray-900 tracking-wide md:tracking-normal">Projects</h3>
              </div>
            </div>

            <div className="mb-3 md:mb-2">
              <div className="text-3xl md:text-2xl font-extrabold md:font-bold text-gray-900 mb-1 md:mb-0.5 tracking-tight md:tracking-normal">
                {projectsLoading ? '...' : projectStats.total}
              </div>
              <div className="flex items-center space-x-4 md:space-x-3 text-[13px] md:text-xs text-slate-600 md:text-gray-600 font-medium md:font-normal">
                <span className="flex items-center space-x-1">
                  <CheckCircle className="w-3.5 h-3.5 text-green-500" />
                  <span>{projectsLoading ? '...' : projectStats.completed} completed</span>
                </span>
                <span className="flex items-center space-x-1">
                  <Clock className="w-3.5 h-3.5 text-blue-500" />
                  <span>{projectsLoading ? '...' : projectStats.inProgress} active</span>
                </span>
              </div>
            </div>

            <div className="w-full bg-gray-200 rounded-full h-1.5">
              <div
                className="bg-blue-600 h-1.5 rounded-full transition-all duration-500"
                style={{ width: `${companyProjects.length > 0 ? overallProgress : 0}%` }}
              ></div>
            </div>
          </button>

          {/* Team Members Card */}
          <button
            onClick={() => onNavigate ? onNavigate('/employees', 'Employee Lists') : navigate('/employees')}
            className={`bg-gradient-to-br from-white to-slate-50 md:bg-white md:bg-none rounded-2xl md:rounded-xl shadow-md md:shadow-sm border border-gray-200/60 md:border-gray-200 p-5 md:p-4 transition-all duration-300 md:duration-200 cursor-pointer text-left ${hoveredCard === 'employees' ? 'md:shadow-md md:transform md:-translate-y-1' : 'md:hover:shadow-md'
              }`}
            onMouseEnter={() => setHoveredCard('employees')}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <div className="flex items-center mb-3 md:mb-2">
              <div className="flex items-center space-x-3 md:space-x-2 mobile-stat-header">
                <div className="p-2.5 md:p-2 bg-green-100 md:bg-green-50 rounded-xl md:rounded-lg shadow-inner md:shadow-none mobile-stat-icon-wrapper">
                  <Users className="w-6 h-6 md:w-5 md:h-5 text-green-700 md:text-green-600" />
                </div>
                <h3 className="text-base md:text-sm font-bold md:font-semibold text-slate-800 md:text-gray-900 tracking-wide md:tracking-normal">Team Members</h3>
              </div>
            </div>

            <div className="mb-3 md:mb-2">
              <div className="text-3xl md:text-2xl font-extrabold md:font-bold text-gray-900 mb-1 md:mb-0.5 tracking-tight md:tracking-normal">
                {employeeLoading ? '...' : companyEmployees.filter(emp => emp.isActive).length}
              </div>
              <div className="text-[13px] md:text-xs text-slate-600 md:text-gray-600 font-medium md:font-normal">
                Active team members
              </div>
            </div>

            <div className="w-full bg-gray-200 rounded-full h-1.5">
              <div
                className="bg-green-600 h-1.5 rounded-full transition-all duration-500"
                style={{ width: `${companyEmployees.length > 0 ? 100 : 0}%` }}
              ></div>
            </div>
          </button>

          {/* Progress Card */}
          <button
            onClick={() => onNavigate ? onNavigate('/reports', 'Reports') : navigate('/reports')}
            className={`bg-gradient-to-br from-white to-slate-50 md:bg-white md:bg-none rounded-2xl md:rounded-xl shadow-md md:shadow-sm border border-gray-200/60 md:border-gray-200 p-5 md:p-4 transition-all duration-300 md:duration-200 cursor-pointer text-left ${hoveredCard === 'progress' ? 'md:shadow-md md:transform md:-translate-y-1' : 'md:hover:shadow-md'
              }`}
            onMouseEnter={() => setHoveredCard('progress')}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <div className="flex items-center mb-3 md:mb-2">
              <div className="flex items-center space-x-3 md:space-x-2 mobile-stat-header">
                <div className="p-2.5 md:p-2 bg-purple-100 md:bg-purple-50 rounded-xl md:rounded-lg shadow-inner md:shadow-none mobile-stat-icon-wrapper">
                  <TrendingUp className="w-6 h-6 md:w-5 md:h-5 text-purple-700 md:text-purple-600" />
                </div>
                <h3 className="text-base md:text-sm font-bold md:font-semibold text-slate-800 md:text-gray-900 tracking-wide md:tracking-normal">Overall Progress</h3>
              </div>
            </div>

            <div className="mb-3 md:mb-2">
              <div className="text-3xl md:text-2xl font-extrabold md:font-bold text-gray-900 mb-1 md:mb-0.5 tracking-tight md:tracking-normal">
                {projectsLoading || statusLoading ? '...' : overallProgress}%
              </div>
              <div className="text-[13px] md:text-xs text-slate-600 md:text-gray-600 font-medium md:font-normal">
                Completion rate across all projects
              </div>
            </div>

            <div className="w-full bg-gray-200 rounded-full h-1.5">
              <div
                className="bg-purple-600 h-1.5 rounded-full transition-all duration-500"
                style={{ width: `${overallProgress}%` }}
              ></div>
            </div>
          </button>
        </div>

        <div id="project-details-grid" className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
          {/* Upcoming Deadlines Section */}
          <div className="bg-gradient-to-b from-white to-slate-50 md:bg-white md:bg-none rounded-2xl md:rounded-xl shadow-lg md:shadow-sm border border-gray-200/80 md:border-gray-200 p-5 md:p-6">
            <div className="flex items-center justify-between mb-5 md:mb-6 border-b border-gray-100 md:border-transparent pb-3 md:pb-0">
              <h2 className="text-lg md:text-xl font-extrabold md:font-semibold text-slate-800 md:text-gray-900 flex items-center space-x-2.5 md:space-x-2">
                <Calendar className="w-6 h-6 md:w-5 md:h-5 text-blue-600 md:text-gray-600" />
                <span className="tracking-wide md:tracking-normal">Upcoming Deadlines</span>
              </h2>
              <span className="text-xs md:text-sm font-bold md:font-normal text-blue-600 md:text-gray-500 bg-blue-50 md:bg-transparent px-2.5 py-1 md:px-0 md:py-0 rounded-full md:rounded-none">
                Next 7 days
              </span>
            </div>

            <div className="space-y-4">
              {upcomingDeadlines.length > 0 ? (
                upcomingDeadlines.map((item, idx) => {
                  const deadline = new Date(item.deadline || item.dueDate);
                  const today = new Date();
                  const daysUntil = Math.ceil((deadline - today) / (1000 * 60 * 60 * 24));

                  const getDeadlineStyle = () => {
                    if (daysUntil <= 1) return 'border-red-200 bg-red-50';
                    if (daysUntil <= 3) return 'border-amber-200 bg-amber-50';
                    return 'border-blue-200 bg-blue-50';
                  };

                  const getIcon = () => {
                    if (daysUntil <= 1) return <AlertTriangle className="w-4 h-4 text-red-500" />;
                    if (daysUntil <= 3) return <Clock className="w-4 h-4 text-amber-500" />;
                    return <Calendar className="w-4 h-4 text-blue-500" />;
                  };

                  return (
                    <div
                      key={`deadline-${idx}`}
                      className={`p-4 md:p-4 rounded-xl md:rounded-lg border-[1.5px] md:border-2 cursor-pointer transition-all duration-200 bg-white shadow-sm md:shadow-none ${getDeadlineStyle()
                        } ${hoveredDeadline === idx ? 'md:transform md:-translate-y-1 md:shadow-md' : 'md:hover:shadow-sm'}`}
                      onClick={() => handleProjectClick(item)}
                      onMouseEnter={() => setHoveredDeadline(idx)}
                      onMouseLeave={() => setHoveredDeadline(null)}
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-3.5 md:space-x-3">
                          <div className="p-2 rounded-full bg-white shadow-sm border border-gray-100 md:p-0 md:bg-transparent md:shadow-none md:border-none">
                            {getIcon()}
                          </div>
                          <div>
                            <h4 className="font-bold md:font-medium text-slate-800 md:text-gray-900 text-[15px] md:text-sm">
                              {item.name || item.title}
                            </h4>
                            <p className="text-xs font-semibold md:font-normal text-slate-500 md:text-gray-600 mt-1 md:mt-1">
                              {daysUntil === 0
                                ? 'Due today'
                                : daysUntil === 1
                                  ? 'Due tomorrow'
                                  : `Due in ${daysUntil} days`}
                            </p>
                          </div>
                        </div>
                        <div className="text-right flex flex-col items-end">
                          <span className="text-xs font-bold md:font-medium text-slate-500 md:text-gray-500 block mb-1.5 md:mb-0">
                            {deadline.toLocaleDateString('en-GB')}
                          </span>
                          <span className="inline-flex items-center px-2.5 py-1 text-[10px] md:text-xs font-bold md:font-medium bg-gradient-to-r from-blue-100 to-indigo-100 md:bg-blue-100 md:bg-none text-blue-800 rounded-full md:mt-1 shadow-sm md:shadow-none">
                            Project
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="text-center py-8">
                  <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-3" />
                  <p className="text-gray-600 font-medium">No upcoming deadlines in the next 7 days</p>
                  <p className="text-sm text-gray-500 mt-1">All caught up!</p>
                </div>
              )}
            </div>
          </div>

          {/* Quick Actions Section */}
          <div className="bg-gradient-to-b from-white to-slate-50 md:bg-white md:bg-none rounded-2xl md:rounded-xl shadow-lg md:shadow-sm border border-gray-200/80 md:border-gray-200 p-5 md:p-6">
            <div className="mb-5 md:mb-6 border-b border-gray-100 md:border-transparent pb-3 md:pb-0">
              <h2 className="text-lg md:text-xl font-extrabold md:font-semibold text-slate-800 md:text-gray-900 flex items-center space-x-2.5 md:space-x-2">
                <Zap className="w-6 h-6 md:w-5 md:h-5 text-amber-500 md:text-gray-600" />
                <span className="tracking-wide md:tracking-normal">Quick Actions</span>
              </h2>
              <p className="text-xs md:text-sm font-medium md:font-normal text-slate-500 md:text-gray-600 mt-1.5 md:mt-1">
                Quickly access frequently used features
              </p>
            </div>

            <div className="space-y-3 md:space-y-4">
              <button
                onClick={() => onNavigate ? onNavigate('/projects/add', 'Add Project') : navigate('/projects/add')}
                className={`w-full flex items-center justify-between p-4 md:p-4 rounded-xl md:rounded-lg border-[1.5px] md:border-2 border-gray-200 bg-white hover:border-blue-500 hover:bg-blue-50 transition-all duration-300 md:duration-200 shadow-sm md:shadow-none ${hoveredAction === 'new-project' ? 'md:border-blue-500 md:bg-blue-50 md:transform md:-translate-y-1' : ''
                  }`}
                onMouseEnter={() => setHoveredAction('new-project')}
                onMouseLeave={() => setHoveredAction(null)}
              >
                <div className="flex items-center space-x-3.5 md:space-x-3">
                  <div className="p-2.5 md:p-2 bg-gradient-to-br from-blue-50 to-blue-100 md:bg-blue-100 md:bg-none rounded-xl md:rounded-lg shadow-inner md:shadow-none border border-blue-200/50 md:border-transparent">
                    <Plus className="w-6 h-6 md:w-5 md:h-5 text-blue-700 md:text-blue-600" />
                  </div>
                  <div className="text-left">
                    <div className="font-bold md:font-medium text-[15px] md:text-base text-slate-800 md:text-gray-900">Create New Project</div>
                    <div className="text-xs md:text-sm font-medium md:font-normal text-slate-500 md:text-gray-600 mt-0.5 md:mt-0">Start a new project</div>
                  </div>
                </div>
                <ChevronRight className="w-5 h-5 md:w-5 md:h-5 text-slate-400 md:text-gray-400 bg-slate-50 md:bg-transparent rounded-full p-0.5 md:p-0" />
              </button>

              <button
                onClick={() => onNavigate ? onNavigate('/kanban', 'Project Tracker') : navigate('/kanban')}
                className={`w-full flex items-center justify-between p-4 md:p-4 rounded-xl md:rounded-lg border-[1.5px] md:border-2 border-gray-200 bg-white hover:border-green-500 hover:bg-green-50 transition-all duration-300 md:duration-200 shadow-sm md:shadow-none ${hoveredAction === 'tracker' ? 'md:border-green-500 md:bg-green-50 md:transform md:-translate-y-1' : ''
                  }`}
                onMouseEnter={() => setHoveredAction('tracker')}
                onMouseLeave={() => setHoveredAction(null)}
              >
                <div className="flex items-center space-x-3.5 md:space-x-3">
                  <div className="p-2.5 md:p-2 bg-gradient-to-br from-green-50 to-green-100 md:bg-green-100 md:bg-none rounded-xl md:rounded-lg shadow-inner md:shadow-none border border-green-200/50 md:border-transparent">
                    <Activity className="w-6 h-6 md:w-5 md:h-5 text-green-700 md:text-green-600" />
                  </div>
                  <div className="text-left">
                    <div className="font-bold md:font-medium text-[15px] md:text-base text-slate-800 md:text-gray-900">Project Tracker</div>
                    <div className="text-xs md:text-sm font-medium md:font-normal text-slate-500 md:text-gray-600 mt-0.5 md:mt-0">Kanban board view</div>
                  </div>
                </div>
                <ChevronRight className="w-5 h-5 md:w-5 md:h-5 text-slate-400 md:text-gray-400 bg-slate-50 md:bg-transparent rounded-full p-0.5 md:p-0" />
              </button>

              <button
                onClick={() => onNavigate ? onNavigate('/reports', 'Reports') : navigate('/reports')}
                className="w-full flex items-center justify-between p-4 md:p-4 rounded-xl md:rounded-lg border-[1.5px] md:border-2 border-gray-200 bg-white hover:border-purple-500 hover:bg-purple-50 transition-all duration-300 md:duration-200 shadow-sm md:shadow-none"
              >
                <div className="flex items-center space-x-3.5 md:space-x-3">
                  <div className="p-2.5 md:p-2 bg-gradient-to-br from-purple-50 to-purple-100 md:bg-purple-100 md:bg-none rounded-xl md:rounded-lg shadow-inner md:shadow-none border border-purple-200/50 md:border-transparent">
                    <BarChart3 className="w-6 h-6 md:w-5 md:h-5 text-purple-700 md:text-purple-600" />
                  </div>
                  <div className="text-left">
                    <div className="font-bold md:font-medium text-[15px] md:text-base text-slate-800 md:text-gray-900">View Reports</div>
                    <div className="text-xs md:text-sm font-medium md:font-normal text-slate-500 md:text-gray-600 mt-0.5 md:mt-0">Analytics & insights</div>
                  </div>
                </div>
                <ChevronRight className="w-5 h-5 md:w-5 md:h-5 text-slate-400 md:text-gray-400 bg-slate-50 md:bg-transparent rounded-full p-0.5 md:p-0" />
              </button>

              <button
                onClick={() => onNavigate ? onNavigate('/employees', 'Employees') : navigate('/employees')}
                className="w-full flex items-center justify-between p-4 md:p-4 rounded-xl md:rounded-lg border-[1.5px] md:border-2 border-gray-200 bg-white hover:border-orange-500 hover:bg-orange-50 transition-all duration-300 md:duration-200 shadow-sm md:shadow-none"
              >
                <div className="flex items-center space-x-3.5 md:space-x-3">
                  <div className="p-2.5 md:p-2 bg-gradient-to-br from-orange-50 to-orange-100 md:bg-orange-100 md:bg-none rounded-xl md:rounded-lg shadow-inner md:shadow-none border border-orange-200/50 md:border-transparent">
                    <Users className="w-6 h-6 md:w-5 md:h-5 text-orange-700 md:text-orange-600" />
                  </div>
                  <div className="text-left">
                    <div className="font-bold md:font-medium text-[15px] md:text-base text-slate-800 md:text-gray-900">Manage Team</div>
                    <div className="text-xs md:text-sm font-medium md:font-normal text-slate-500 md:text-gray-600 mt-0.5 md:mt-0">Team members</div>
                  </div>
                </div>
                <ChevronRight className="w-5 h-5 md:w-5 md:h-5 text-slate-400 md:text-gray-400 bg-slate-50 md:bg-transparent rounded-full p-0.5 md:p-0" />
              </button>
            </div>
          </div>
        </div>

        {/* Recent Activity Section (Placeholder for future enhancement) */}
        <div id="project-activity-card" className="mt-6 md:mt-8 bg-gradient-to-b from-white to-slate-50 md:bg-white md:bg-none rounded-2xl md:rounded-xl shadow-lg md:shadow-sm border border-gray-200/80 md:border-gray-200 p-5 md:p-6">
          <div className="flex items-center justify-between mb-5 md:mb-6 border-b border-gray-100 md:border-transparent pb-3 md:pb-0">
            <h2 className="text-lg md:text-xl font-extrabold md:font-semibold text-slate-800 md:text-gray-900 flex items-center space-x-2.5 md:space-x-2">
              <Target className="w-6 h-6 md:w-5 md:h-5 text-red-500 md:text-gray-600" />
              <span className="tracking-wide md:tracking-normal">Recent Activity</span>
            </h2>
            <span className="text-xs md:text-sm font-bold md:font-normal text-slate-500 md:text-gray-500 bg-slate-100 md:bg-transparent px-2.5 py-1 md:px-0 md:py-0 rounded-full md:rounded-none">
              Last 30 days
            </span>
          </div>
          <div className="text-center py-6 md:py-8 bg-white md:bg-transparent rounded-xl md:rounded-none border border-gray-100 md:border-none shadow-sm md:shadow-none">
            <div className="text-slate-300 md:text-gray-400 mb-3 md:mb-2">
              <Activity className="w-12 h-12 md:w-12 md:h-12 mx-auto" />
            </div>
            <p className="text-slate-700 md:text-gray-600 font-bold md:font-medium text-[15px] md:text-base">Activity tracking coming soon</p>
            <p className="text-xs md:text-sm font-medium md:font-normal text-slate-500 md:text-gray-500 mt-1 md:mt-1">Monitor project updates and team activity</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
